/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ConnectedAudiologistDTO,
  ConnectedAudiologistUpdateDTO,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetAudiologistsOfSupplierParams,
  InternalServerErrorResponse,
  PaginatedConnectedAudiologistListItemsDTO,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns a connected audiologists of a given supplier by id
 * @summary Get connected audiologist of a supplier by id
 */
export type getAudiologistOfSupplierByIdResponse = {
  data: ConnectedAudiologistDTO;
  status: number;
};

export const getGetAudiologistOfSupplierByIdUrl = (
  supplierId: string,
  audiologistId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/${audiologistId}`;
};

export const getAudiologistOfSupplierById = async (
  supplierId: string,
  audiologistId: string,
  options?: RequestInit
): Promise<getAudiologistOfSupplierByIdResponse> => {
  return customFetchInstance<Promise<getAudiologistOfSupplierByIdResponse>>(
    getGetAudiologistOfSupplierByIdUrl(supplierId, audiologistId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetAudiologistOfSupplierByIdQueryKey = (
  supplierId: string,
  audiologistId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/${audiologistId}`,
  ] as const;
};

export const getGetAudiologistOfSupplierByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAudiologistOfSupplierByIdQueryKey(supplierId, audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudiologistOfSupplierById>>
  > = ({ signal }) =>
    getAudiologistOfSupplierById(supplierId, audiologistId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && audiologistId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudiologistOfSupplierByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudiologistOfSupplierById>>
>;
export type GetAudiologistOfSupplierByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAudiologistOfSupplierById<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistOfSupplierById<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistOfSupplierById<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get connected audiologist of a supplier by id
 */

export function useGetAudiologistOfSupplierById<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAudiologistOfSupplierByIdQueryOptions(
    supplierId,
    audiologistId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAudiologistOfSupplierByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAudiologistOfSupplierByIdQueryKey(supplierId, audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudiologistOfSupplierById>>
  > = ({ signal }) =>
    getAudiologistOfSupplierById(supplierId, audiologistId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && audiologistId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudiologistOfSupplierByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudiologistOfSupplierById>>
>;
export type GetAudiologistOfSupplierByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAudiologistOfSupplierByIdSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistOfSupplierByIdSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistOfSupplierByIdSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get connected audiologist of a supplier by id
 */

export function useGetAudiologistOfSupplierByIdSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistOfSupplierById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAudiologistOfSupplierByIdSuspenseQueryOptions(
    supplierId,
    audiologistId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates an audiologists supplier specific chainnumber.
Can throw the following error codes:
`ERR_SCL_CHAIN_NUMBER_UNKNOWN`, `ERR_SCL_CHAIN_NUMBER_ALREADY_REGISTERED`

Further explanation about the error codes can be found in the projects README.

 * @summary Updates an audiologists supplier specific chainnumber
 */
export type updateConnectedAudiologistResponse = {
  data: ConnectedAudiologistDTO;
  status: number;
};

export const getUpdateConnectedAudiologistUrl = (
  supplierId: string,
  audiologistId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/${audiologistId}`;
};

export const updateConnectedAudiologist = async (
  supplierId: string,
  audiologistId: string,
  connectedAudiologistUpdateDTO: ConnectedAudiologistUpdateDTO,
  options?: RequestInit
): Promise<updateConnectedAudiologistResponse> => {
  return customFetchInstance<Promise<updateConnectedAudiologistResponse>>(
    getUpdateConnectedAudiologistUrl(supplierId, audiologistId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(connectedAudiologistUpdateDTO),
    }
  );
};

export const getUpdateConnectedAudiologistMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectedAudiologist>>,
    TError,
    {
      supplierId: string;
      audiologistId: string;
      data: ConnectedAudiologistUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConnectedAudiologist>>,
  TError,
  {
    supplierId: string;
    audiologistId: string;
    data: ConnectedAudiologistUpdateDTO;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConnectedAudiologist>>,
    {
      supplierId: string;
      audiologistId: string;
      data: ConnectedAudiologistUpdateDTO;
    }
  > = (props) => {
    const { supplierId, audiologistId, data } = props ?? {};

    return updateConnectedAudiologist(
      supplierId,
      audiologistId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConnectedAudiologistMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConnectedAudiologist>>
>;
export type UpdateConnectedAudiologistMutationBody =
  ConnectedAudiologistUpdateDTO;
export type UpdateConnectedAudiologistMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates an audiologists supplier specific chainnumber
 */
export const useUpdateConnectedAudiologist = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConnectedAudiologist>>,
    TError,
    {
      supplierId: string;
      audiologistId: string;
      data: ConnectedAudiologistUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConnectedAudiologist>>,
  TError,
  {
    supplierId: string;
    audiologistId: string;
    data: ConnectedAudiologistUpdateDTO;
  },
  TContext
> => {
  const mutationOptions = getUpdateConnectedAudiologistMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Deletes an audiologists supplier specific chainnumber
 * @summary Deletes an audiologists supplier specific chainnumber
 */
export type deleteConnectedAudiologistResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeleteConnectedAudiologistUrl = (
  supplierId: string,
  audiologistId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/${audiologistId}`;
};

export const deleteConnectedAudiologist = async (
  supplierId: string,
  audiologistId: string,
  options?: RequestInit
): Promise<deleteConnectedAudiologistResponse> => {
  return customFetchInstance<Promise<deleteConnectedAudiologistResponse>>(
    getDeleteConnectedAudiologistUrl(supplierId, audiologistId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeleteConnectedAudiologistMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConnectedAudiologist>>,
    TError,
    { supplierId: string; audiologistId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConnectedAudiologist>>,
  TError,
  { supplierId: string; audiologistId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConnectedAudiologist>>,
    { supplierId: string; audiologistId: string }
  > = (props) => {
    const { supplierId, audiologistId } = props ?? {};

    return deleteConnectedAudiologist(
      supplierId,
      audiologistId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConnectedAudiologistMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConnectedAudiologist>>
>;

export type DeleteConnectedAudiologistMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes an audiologists supplier specific chainnumber
 */
export const useDeleteConnectedAudiologist = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConnectedAudiologist>>,
    TError,
    { supplierId: string; audiologistId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteConnectedAudiologist>>,
  TError,
  { supplierId: string; audiologistId: string },
  TContext
> => {
  const mutationOptions = getDeleteConnectedAudiologistMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a paginated list of all audiologists connected via the chainnumbers to the given supplier
 * @summary Get audiologists of a supplier
 */
export type getAudiologistsOfSupplierResponse = {
  data: PaginatedConnectedAudiologistListItemsDTO;
  status: number;
};

export const getGetAudiologistsOfSupplierUrl = (
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists`;
};

export const getAudiologistsOfSupplier = async (
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: RequestInit
): Promise<getAudiologistsOfSupplierResponse> => {
  return customFetchInstance<Promise<getAudiologistsOfSupplierResponse>>(
    getGetAudiologistsOfSupplierUrl(supplierId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetAudiologistsOfSupplierQueryKey = (
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAudiologistsOfSupplierQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAudiologistsOfSupplierQueryKey(supplierId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudiologistsOfSupplier>>
  > = ({ signal }) =>
    getAudiologistsOfSupplier(supplierId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudiologistsOfSupplierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudiologistsOfSupplier>>
>;
export type GetAudiologistsOfSupplierQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params: undefined | GetAudiologistsOfSupplierParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get audiologists of a supplier
 */

export function useGetAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAudiologistsOfSupplierQueryOptions(
    supplierId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAudiologistsOfSupplierSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAudiologistsOfSupplierQueryKey(supplierId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudiologistsOfSupplier>>
  > = ({ signal }) =>
    getAudiologistsOfSupplier(supplierId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudiologistsOfSupplierSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudiologistsOfSupplier>>
>;
export type GetAudiologistsOfSupplierSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params: undefined | GetAudiologistsOfSupplierParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get audiologists of a supplier
 */

export function useGetAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetAudiologistsOfSupplierParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAudiologistsOfSupplierSuspenseQueryOptions(
    supplierId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a `csv` file containing the complete list of the supplier's audiologists`.
 * @summary Get audiologists of a supplier
 */
export type downloadAudiologistsOfSupplierResponse = {
  data: Blob;
  status: number;
};

export const getDownloadAudiologistsOfSupplierUrl = (supplierId: string) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/download`;
};

export const downloadAudiologistsOfSupplier = async (
  supplierId: string,
  options?: RequestInit
): Promise<downloadAudiologistsOfSupplierResponse> => {
  return customFetchInstance<Promise<downloadAudiologistsOfSupplierResponse>>(
    getDownloadAudiologistsOfSupplierUrl(supplierId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getDownloadAudiologistsOfSupplierQueryKey = (
  supplierId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/audiologists/download`,
  ] as const;
};

export const getDownloadAudiologistsOfSupplierQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAudiologistsOfSupplierQueryKey(supplierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>
  > = ({ signal }) =>
    downloadAudiologistsOfSupplier(supplierId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadAudiologistsOfSupplierQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>
>;
export type DownloadAudiologistsOfSupplierQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useDownloadAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get audiologists of a supplier
 */

export function useDownloadAudiologistsOfSupplier<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadAudiologistsOfSupplierQueryOptions(
    supplierId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadAudiologistsOfSupplierSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAudiologistsOfSupplierQueryKey(supplierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>
  > = ({ signal }) =>
    downloadAudiologistsOfSupplier(supplierId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadAudiologistsOfSupplierSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>
>;
export type DownloadAudiologistsOfSupplierSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useDownloadAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get audiologists of a supplier
 */

export function useDownloadAudiologistsOfSupplierSuspense<
  TData = Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadAudiologistsOfSupplier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadAudiologistsOfSupplierSuspenseQueryOptions(
    supplierId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
